import { OxygenSaturationScale } from '../types';

export const getOxygenSaturationScale = (
  oxygenFlowRate = 0,
  useScale2Air = false,
): OxygenSaturationScale => {
  if (oxygenFlowRate > 0) {
    return OxygenSaturationScale.Scale2Oxygen;
  }

  if (useScale2Air) {
    return OxygenSaturationScale.Scale2Air;
  }
  return OxygenSaturationScale.Scale1;
};
